import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,
  IcecontrolPermission,
  IceexpansionpanelSettings
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { IceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { IBaseView } from '../../../../icemedx-lib/src/components/baseview.component';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { superbill } from '../../../../icemedx-lib/src/models/accounting/superbill';
import { basecodereference } from '../../../../icemedx-lib/src/models/ehr/subs/basecodereference';
import { subtypereference } from '../../../../icemedx-lib/src/models/ehr/subs/subtypereference';

const BillingActionDomainType = "BillingActionDomainType";

@Component({
  selector: 'app-billtemplate',
  templateUrl: './billtemplate.component.html',
  styleUrls: ['./billtemplate.component.scss'],
  providers: [AppService, IceNavService]
})
export class BillTemplateComponent implements OnInit, IBaseView {
  // data members
  sBill: superbill = null;
  srcTypeMapDataSource: any = {};
  newItemMap: any = {};

  // member settings
  billingTemplateViewSettings: IcepanelcontainerSettings = null;
  billingPermission: IcecontrolPermission = null;
  srcTypeMapTable: any = {};

  //////////////////////
  // Order Info. Controls
  private nameOfTemplateCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { placeholder: "Enter Name of Template", width: "450px" },
    null, null, "IDNameOfTemplate")
    .setControlName("IDNameOfTemplate")
    .createFormControl("", [Validators.required]);

  private ctrlBillingDomainType: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: DomainService.getDomainTypes(), width: "250px" }, null, null, BillingActionDomainType, "Type of Bill") // Type of Receiving or Checkout Bill
    .setControlName(BillingActionDomainType)
    .createFormControl(0, [Validators.required]);

  private taxonomyCodeCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { placeholder: "Select Taxonomy", menuItems: [], width: "450px" },
          null, null, "IDTaxonomyCode")
    .setControlName("IDTaxonomyCode")
    .createFormControl("", [Validators.required]);

  private billingDomainSection: IcepanelsectionSettings = null;
  private billingOptionSection: IcepanelsectionSettings = null;
  private billingPanel = null;

  private titleCtrl = null;

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private accSvc: AccountingService,
    private medCodeSvc: MedicalcodesService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {

    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Billing Template", {}, true, "");

    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;
    this.billingPermission = new IcecontrolPermission(userTypes.USER_FEATURES.ufSuperBill, feaAccess);

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      return;
    }

    this.activatedRoute.params.subscribe(next => {
      if (next == null || next.key == "0" || next.length == 0) {
        this.billingTemplateViewSettings = this.viewSetup(new superbill());
      }
      else {
        this.accSvc.getBillTemplate(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), next.key).subscribe(
          data => {
            if (data && data.length > 0 && data[0] != null) {
              this.billingTemplateViewSettings = this.viewSetup(data[0]);
            }
          },
          error => {
            console.log(JSON.stringify(this.accSvc.getLastErrors()));
          });
      }
    });
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  getBreadcrumbs(): any {
    return this.appSvc.getBreadcrumbs();
  }

  createBillingPanel(): IcepanelSettings {
    let panel: IcepanelSettings = null;
    try {
      let headerControls = [
        new IcecontrolSettings("icebutton", { class: "fas fa-check", width: "50px" }, null, null, "SaveReport"),
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "CancelReport")
      ];

      let controls: IcecontrolSettings[] = [
        this.nameOfTemplateCtrl,
        this.ctrlBillingDomainType,
        this.taxonomyCodeCtrl,
      ];

      this.billingDomainSection = new IcepanelsectionSettings("BillingDomainPanelSection", { class: [""], styles: { width: "100%" } }, null,
        controls, []).setShow(true);

      this.billingOptionSection = new IcepanelsectionSettings("BillingOptionSection", { class: [""], styles: { width: "100%" } }, [], [
        //To do,
      ], []).setShow(false);

      let sections: IcepanelsectionSettings[] = [
        this.billingDomainSection,
        this.billingOptionSection
      ];
      panel = new IcepanelSettings("BillingPanel", Iceutility.guid(false), "Billing Template", "", sections, headerControls)
        .enableForm();
    }
    catch (e) {
      console.log(e);
    }
    return panel;
  }

  viewSetup(dat: IceEntity): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;

      if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
        this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
        return null;
      }
      if (dat == null) {
        return null;
      }

      this.sBill = <superbill>dat;

      this.billingPanel = this.createBillingPanel()
        .enableForm().setLoading(true);

      let panels: IcepanelSettings[] = [
        this.billingPanel,
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("ServiceItemViewContainer", panelrows);

      this.nameOfTemplateCtrl.getFormControl().setValue(this.sBill.name);
      this.ctrlBillingDomainType.getFormControl().setValue(Iceutility.toLong(this.sBill.account_type));
      this.appSvc.setTaxonomyCodeList(this.medCodeSvc, this.taxonomyCodeCtrl, [],
        () => {
          this.taxonomyCodeCtrl.getFormControl().setValue(this.sBill.taxonomy_code);
        });

      this.medCodeSvc.getCodes("SUBTYPE_ITEM_HIERARCHY", "", "", "").subscribe(
        data => {
          if (data == null || data.length == 0) return;

          let heir = data[0];
          try {
            let allrefs = JSON.parse(heir.code);
            let hierarchy = JSON.parse(heir.title);
            let subobjs = JSON.parse(heir.description);

            for (let srctyp = IceTypes.SourceType.srcUndefined; srctyp < IceTypes.SourceType.srcLast; srctyp++) {
              this.loadGroup(panels, srctyp, subobjs, allrefs, hierarchy, false, "");
            }
            this.billingPanel.setLoading(false);
          }
          catch (e) {
            this.billingPanel.setLoading(false);
            console.log(e);
          }
        }, error => {
          this.billingPanel.setLoading(false);
          console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
        });
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  buildSectionTag(srctyp: IceTypes.SourceType): string {
    return "NewSection:" + srctyp.toString() + ":";
  }

  parseSectionKey(val: string): IceTypes.SourceType {
    let srctype: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;
    if (val == null || val.length == 0) return srctype;

    let parts = val.split(":");
    if (parts.length > 1)
      srctype = <IceTypes.SourceType>Iceutility.toLong(parts[1]);

    return srctype;
  }

  parseTableKey(val: string): IceTypes.SourceType {
    let srctype: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;
    if (val == null || val.length == 0) return srctype;
    let parts = val.split(":");
    if (parts.length > 0)
      srctype = <IceTypes.SourceType>Iceutility.toLong(parts[0]);

    return srctype;
  }

  parseTableSubType(val: string): number {
    let subtype: number = 0;
    if (val == null || val.length == 0) return subtype;
    let parts = val.split(":");
    if (parts.length > 2)
      subtype = <number>Iceutility.toLong(parts[2]);

    return subtype;
  }

  loadGroup(panels: IcepanelSettings[],
    srctyp: IceTypes.SourceType,
    subtypeobjs: any,
    allrefs: any,
    hier: any,
    showaddlink: boolean,
    addlinkvalue: string): boolean {
    if (null == panels || panels.length == 0)
      return false;

    if (subtypeobjs == null)
      return false;

    if (srctyp == IceTypes.SourceType.srcUndefined
      || srctyp == IceTypes.SourceType.srcClinicalResults
      || srctyp == IceTypes.SourceType.srcCare
      || srctyp == IceTypes.SourceType.srcReferral
      || srctyp == IceTypes.SourceType.srcFamilyConference
      || srctyp == IceTypes.SourceType.srcStatement
      || srctyp == IceTypes.SourceType.srcPayment
      || srctyp == IceTypes.SourceType.srcToothPlan
      || srctyp == IceTypes.SourceType.srcEncounterNotes
      || srctyp == IceTypes.SourceType.srcCoPay
      || srctyp == IceTypes.SourceType.srcPatientDemographics
      || srctyp == IceTypes.SourceType.srcAllergies
      || srctyp == IceTypes.SourceType.srcImage
      || srctyp == IceTypes.SourceType.srcTreatmentPlan
      || srctyp == IceTypes.SourceType.srcERA
      || srctyp == IceTypes.SourceType.srcPatientPhoto
      || srctyp == IceTypes.SourceType.srcCCD
      || srctyp == IceTypes.SourceType.srcVitals
      || srctyp == IceTypes.SourceType.srcMiscellaneousForms)
      return true;

    let frmGrp = panels[0].getForm();

    let srcpanel: IcepanelSettings = null;
    try {
      let stypeDesc = AccountingService.getSourceType(srctyp);

      let srcMapKey = srctyp.toString();

      let tables: IcemattableSettings[] = [];

      // Do the general template item
      let hidePricing = srctyp == IceTypes.SourceType.srcDiagnosis;
      this.srcTypeMapDataSource[srcMapKey] = new MatTableDataSource<any>([]);
      this.srcTypeMapTable[srcMapKey] = new IcemattableSettings(
        srcMapKey,
        [
          new iceColumnDefinition("title", stypeDesc + Iceutility.renderRightArrow() + "General items", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Enter Title", width: "350px" }, null, null)),
          new iceColumnDefinition("code", "Code", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Code", width: "100px" }, null, null)),
          new iceColumnDefinition("price", "Price", false, hidePricing,
            new IcecontrolSettings("icelabel", { placeholder: "Price", width: "75px" }, null, null)),
          new iceColumnDefinition("tax_status", "Tax Status", hidePricing, false,
            new IcecontrolSettings("icelabel", { placeholder: "Tax Status", width: "75px" }, null, null)),
          new iceColumnDefinition("base_code_key", "base_code_key", false, true),
          new iceColumnDefinition("base_code_reference_key", "base_code_reference_key", true),
          new iceColumnDefinition("QuickActions", "", false, false),
        ],
        this.srcTypeMapDataSource[srcMapKey],
        [],
        false,
        null,
        true
      ).showAddButton(true);
      tables.push(this.srcTypeMapTable[srcMapKey]);

      let foundSubTypes = this.sBill.SUBTYPES.filter(sub => sub.src_type == srctyp && sub.sub_type == 0);
      if (foundSubTypes.length > 0) {
        let codes: any = foundSubTypes[0].CODES;
        codes.map(c => c.tax_status = AccountingService.getTaxStatus(c.tax_status));
        this.srcTypeMapDataSource[srcMapKey].data = codes;
      }

      for (let stypGrpKey in subtypeobjs) {
        let subtypeGrpOb = subtypeobjs[stypGrpKey];
        if (subtypeGrpOb == null) continue;

        if (subtypeGrpOb["SRCTYPES"] == null) subtypeGrpOb["SRCTYPES"] = [];
        if (subtypeGrpOb["SUBITEMS"] == null) subtypeGrpOb["SUBITEMS"] = [];

        let foundTypes = subtypeGrpOb["SRCTYPES"].filter((s) => Iceutility.toLong(s.SRC_TYPE) == srctyp);
        if (foundTypes.length > 0) {
          let grpkey = subtypeGrpOb["SUBTYPE_GROUP_KEY"];

          for (let isubitem = 0; isubitem < subtypeGrpOb["SUBITEMS"].length; isubitem++) {
            let subitem = subtypeGrpOb["SUBITEMS"][isubitem];
            if (subitem == null) continue;
            let subtype = subitem["SUB_TYPE"];

            hidePricing = srctyp == IceTypes.SourceType.srcDiagnosis;
            let subTypeMapDescription = stypeDesc + Iceutility.renderRightArrow() + subtypeGrpOb["NAME"] + Iceutility.renderRightArrow() + subitem["TITLE"];
            let subTypeMapKey = srcMapKey + ":" + grpkey + ":" + subtype.toString();
            this.srcTypeMapDataSource[subTypeMapKey] = new MatTableDataSource<any>([]);
            this.srcTypeMapTable[subTypeMapKey] = new IcemattableSettings(
              subTypeMapKey,
              [
                new iceColumnDefinition("title", subTypeMapDescription, false, false,
                  new IcecontrolSettings("icelabel", { placeholder: "Enter Title", width: "350px" }, null, null)),
                new iceColumnDefinition("code", "Code", false, false,
                  new IcecontrolSettings("icelabel", { placeholder: "Code", width: "100px" }, null, null)),
                new iceColumnDefinition("price", "Price", false, hidePricing,
                  new IcecontrolSettings("icelabel", { placeholder: "Price", width: "75px" }, null, null)),
                new iceColumnDefinition("tax_status", "Tax Status", hidePricing, false,
                  new IcecontrolSettings("icelabel", { placeholder: "Tax Status", width: "75px" }, null, null)),
                new iceColumnDefinition("base_code_key", "base_code_key", false, true),
                new iceColumnDefinition("base_code_reference_key", "base_code_reference_key", true),
                new iceColumnDefinition("QuickActions", "", false, false),
              ],
              this.srcTypeMapDataSource[subTypeMapKey],
              [],
              false,
              null,
              true
            ).showAddButton(true);
            tables.push(this.srcTypeMapTable[subTypeMapKey]);

            //load sbill.subtypereference data source
            foundSubTypes = this.sBill.SUBTYPES.filter(sub => sub.src_type == srctyp && sub.sub_type == Iceutility.toLong(subtype));
            if (foundSubTypes.length > 0) {
              let codes: any = foundSubTypes[0].CODES;
              codes.map(c => c.tax_status = AccountingService.getTaxStatus(c.tax_status));
              this.srcTypeMapDataSource[subTypeMapKey].data = codes;

            }
          }
        }
      }

      if (tables.length == 0) { // If no tables then add default
        // To do
      }

      let groups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, tables)
      ];

      let sections: IcepanelsectionSettings[] = [];

      let secTag = this.buildSectionTag(srctyp);

      let priceCtrl = new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "price", "Enter Price")
        .setControlName("price")
        .createFormControl("", [Validators.required]);

      let taxStatusCtrl = new IcecontrolSettings("iceselect", { menuItems: [{ name: "Non-Taxable", value: IceTypes.sales_tax_status.stsNonTaxable }, { name: "Taxable", value: IceTypes.sales_tax_status.stsTaxable }], width: "200px" }, null, null, "tax_status", "Select Tax Status")
        .setControlName("tax_status")
        .createFormControl("", [Validators.required]);
      
      let titleCtrl = new IcecontrolSettings(srctyp == IceTypes.SourceType.srcOther ? "iceautocomplete" : "iceinput", { menuItems: [], width: "200px", section: secTag }, null, null, "title", "Enter Title")
        .setControlName("title")
        .createFormControl("", [Validators.required])

      let codeCtrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "200px", section: secTag }, null, null, "code", "Enter Code")
        .setControlName("code")
        .createFormControl("", [Validators.required])

      let idControls = [
        titleCtrl,
        codeCtrl
      ];

      if (srctyp != IceTypes.SourceType.srcDiagnosis) {
        idControls.push(priceCtrl);
        idControls.push(taxStatusCtrl);
      }

      sections.push(this.appSvc.viewEditPanelSection(secTag, idControls, true));
      sections.push(new IcepanelsectionSettings(secTag, { class: [""], styles: { width: "100%" } }, groups, [], []));

      srcpanel = new IceexpansionpanelSettings("SourcePanel" + srctyp.toString(), srctyp.toString(), stypeDesc, "", sections, null, null, null)
        .enableForm(frmGrp);

      panels.push(srcpanel);
    }
    catch(e)
    {
      console.log(e);
      return false;
    }
    return true;
  }

  getBillingType(): IceTypes.ACCOUNT_TYPE {
    let ret: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.ctrlBillingDomainType.getFormControl();
    if (ctrType != null) {
      ret = ctrType.value;
    }
    return ret;
  }


  /////////////////////////////////////
  // Events
  onControlChange(event) {
    if (event.selectSettings != null) {
      switch (event.selectSettings.id) {
        case BillingActionDomainType: {
          switch (this.getBillingType()) {
            case IceTypes.ACCOUNT_TYPE.actPatient: {
              // Fall through and do lookup upon keyword search
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actProvider:
            case IceTypes.ACCOUNT_TYPE.actFacility: {
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actPharmacy: {
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actVendor: {
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actPayer: {
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actSubscriber: {
              // Fall through and do lookup upon keyword search
              break;
            }
            default: {
              // To do error to user
              return;
            }
          }
          break;
        }
      }
    }
    else if (event.autocompleteSettings != null) {
    }
    else if (event.autocompleteRemoveSettings != null) {
    }
    else if (Iceutility.isdefined(event.autocompleteQuerySettings)) {
      switch (event.autocompleteQuerySettings.id) { // To do: Move this to the new autocompleteQuery event
        case "title": {
          if (event["value"] != null && event["value"].length >= 3 && event.autocompleteQuerySettings.properties["section"] != null) {
            let sectionTag = event.autocompleteQuerySettings.properties["section"];
            let srctype: IceTypes.SourceType = this.parseSectionKey(sectionTag);            
            let editSect = this.appSvc.getEditPanelSection(sectionTag);
            if (editSect != null) {
              let ctrls = editSect.controls.filter(c => c.id == "title");
              if (ctrls.length > 0) {
                switch (srctype) {
                  case IceTypes.SourceType.srcDiagnosis: {
                    this.appSvc.setCodeList(this.medCodeSvc, new basecode("ICDCODE"), ctrls[0], [], false, event["value"]);
                    break;
                  }
                  case IceTypes.SourceType.srcTypeOfService:
                  case IceTypes.SourceType.srcTestProcedure:
                  case IceTypes.SourceType.srcProcedure:
                  case IceTypes.SourceType.srcXRayRad:
                  case IceTypes.SourceType.srcCareDetail:
                  case IceTypes.SourceType.srcEncounterNotes:
                  case IceTypes.SourceType.srcExam:
                  case IceTypes.SourceType.srcToothService:
                  case IceTypes.SourceType.srcService: {
                    this.newItemMap[sectionTag].code_list_qualifier_code = "BO";
                    this.newItemMap[sectionTag].price = 0.0;
                    this.newItemMap[sectionTag].tax_status = IceTypes.sales_tax_status.stsNonTaxable;
                    let editSect = this.appSvc.getEditPanelSection(sectionTag);
                    if (editSect != null) {
                      let ctrls = editSect.controls.filter(c => c.id == "title");
                      if (ctrls.length > 0) {
                        this.appSvc.setCodeList(this.medCodeSvc, new basecode("CPTCODE"), ctrls[0], [], false, event["value"]);
                      }
                    }
                    break;
                  }
                  case IceTypes.SourceType.srcPrescriptionRefill:
                  case IceTypes.SourceType.srcMedication:
                  case IceTypes.SourceType.srcImmunization: {
                    this.newItemMap[sectionTag].code_list_qualifier_code = "NDC";
                    this.newItemMap[sectionTag].price = 0.0;
                    this.newItemMap[sectionTag].tax_status = IceTypes.sales_tax_status.stsNonTaxable;
                    let editSect = this.appSvc.getEditPanelSection(sectionTag);
                    if (editSect != null) {
                      let ctrls = editSect.controls.filter(c => c.id == "title");
                      if (ctrls.length > 0) {
                        this.appSvc.setCodeList(this.medCodeSvc, new basecode("NDCCODE"), ctrls[0], [], false, event["value"]);
                      }
                    }
                    break;
                  }
                  case IceTypes.SourceType.srcOther: {
                    this.newItemMap[sectionTag].code_list_qualifier_code = "";
                    // To do inventory lookup
                    break;
                  }

                }                
              }
            }
          }
          break;
        }
      }
    }
  }


  onButtonClick(event) {
    if (event.buttonSettings != null) {
      switch (event.buttonSettings.id) {
        default: {
          let id: string = event.buttonSettings.id;
          let srctype: IceTypes.SourceType = this.parseSectionKey(id);
          
          // Add New Item to template
          let sectionTag = this.buildSectionTag(srctype);
          if (this.appSvc.processEditPanelSectionButtons(sectionTag, event.buttonSettings.id)) {
            let bcoderef: basecodereference = this.newItemMap[sectionTag];
            let tableTag: string = bcoderef["TableTag"];
            if (tableTag != null && tableTag.length > 0) {
              let dataSrc = this.srcTypeMapDataSource[tableTag];
              if (dataSrc != null) {
                try {                 
                  if (!Iceutility.isstring(bcoderef.title)) {                    
                    let tObj = JSON.parse(bcoderef.title);
                    if (tObj != null && tObj.length > 0 && Iceutility.isobject(tObj[0])) {
                      bcoderef.title = tObj[0]["name"];
                      bcoderef.code = tObj[0]["value"];
                    }
                  }
                }
                catch (e) {
                  console.log(e);
                }

                if (bcoderef.base_code_reference_key == "") {
                  bcoderef.base_code_reference_key = Iceutility.guid(true).toUpperCase();
                  dataSrc.data.push(bcoderef);
                }
                dataSrc.data = dataSrc.data;
              }
            }

            // Reset;
            this.newItemMap[sectionTag] = null;
          }
          break;
        }
      }
    }
  }

  public onAddRowButtonClick(event) {
    if (event.matTableSettings != null) {
      let tag: string = event.matTableSettings.tag;
      let srctype: IceTypes.SourceType = this.parseTableKey(tag);

      let sectionTag = this.buildSectionTag(srctype);
      this.appSvc.showEditPanelSection(sectionTag, 1);
      this.newItemMap[sectionTag] = null; // reset
      this.newItemMap[sectionTag] = new basecodereference();
      this.newItemMap[sectionTag].base_code_reference_key = "";
      this.newItemMap[sectionTag]["TableTag"] = tag;
      this.newItemMap[sectionTag].title = "Utitled Item";
      this.newItemMap[sectionTag].code = "";
      this.newItemMap[sectionTag].off
      this.appSvc.editPanelSectionUpdate(sectionTag, false, this.newItemMap[sectionTag]);

      switch (srctype) {
        case IceTypes.SourceType.srcDiagnosis: {
          this.newItemMap[sectionTag].code_list_qualifier_code = "BQ";
          break;
        }
        case IceTypes.SourceType.srcTypeOfService:
        case IceTypes.SourceType.srcTestProcedure:
        case IceTypes.SourceType.srcProcedure:
        case IceTypes.SourceType.srcXRayRad:
        case IceTypes.SourceType.srcCareDetail:
        case IceTypes.SourceType.srcEncounterNotes:
        case IceTypes.SourceType.srcExam:
        case IceTypes.SourceType.srcToothService:
        case IceTypes.SourceType.srcService: {
          this.newItemMap[sectionTag].code_list_qualifier_code = "BO";
          this.newItemMap[sectionTag].price = 0.0;
          this.newItemMap[sectionTag].tax_status = IceTypes.sales_tax_status.stsNonTaxable;
          break;
        }
        case IceTypes.SourceType.srcPrescriptionRefill:
        case IceTypes.SourceType.srcMedication:
        case IceTypes.SourceType.srcImmunization: {
          this.newItemMap[sectionTag].code_list_qualifier_code = "NDC";
          this.newItemMap[sectionTag].price = 0.0;
          this.newItemMap[sectionTag].tax_status = IceTypes.sales_tax_status.stsNonTaxable;
          break;
        }
        case IceTypes.SourceType.srcOther: {
          this.newItemMap[sectionTag].code_list_qualifier_code = "";
          break;
        }

      }
    }
  }

  onMatGridRowClick(event) {
    let tag: string = event.matTableSettings.tag;
    let srctype: IceTypes.SourceType = this.parseTableKey(tag);
    let sectionTag = this.buildSectionTag(srctype);
    this.appSvc.showEditPanelSection(sectionTag, 1);
    this.newItemMap[sectionTag] = event["rowData"]; // reset
    this.appSvc.editPanelSectionUpdate(sectionTag, false, this.newItemMap[sectionTag]);
  }

  onMatGridRowActionClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }

    /*
    if (ItemActionType.templateItemEdit == event.actionItem.value) {
      let item = <basecodereference>event["rowData"];
      if (item == null) {
        // To do log error
        return;
      }
    }
    else if (ItemActionType.templateItemRemove == event.actionItem.value) {
    }
    */
  }

  public onHeaderActionClick(event) {
    if (event.headerCtrl && event.headerCtrl.id == "") {
      return;
    }

    if (event.headerCtrl && event.headerCtrl.id == "CancelReport") {
      // To do: Save Modified Prompt
      this.router.navigate([this.navSvc.buildRoute("accounting/billingtemplates", false)]);
      return;
    }

    if (event.headerCtrl instanceof IcecontrolSettings) {
      let billForm: FormGroup = this.billingPanel.getForm();
      if (billForm == null || false == billForm.valid) {

        // To do log error
        return;
      }

      this.sBill.name = this.nameOfTemplateCtrl.getFormControl().value;
      this.sBill.account_type = <IceTypes.ACCOUNT_TYPE>Iceutility.toLong(this.ctrlBillingDomainType.getFormControl().value);
      this.sBill.taxonomy_code = this.taxonomyCodeCtrl.getFormControl().value;

      // To do validation
      //if () {
      //  this.accSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: .....");
      //  return;
      //}

      try {
        for (const srckey in this.srcTypeMapDataSource) {
          let dataSrc: MatTableDataSource<any> = <MatTableDataSource<any>>this.srcTypeMapDataSource[srckey];
          if (dataSrc == null) continue;

          let srctype = this.parseTableKey(srckey);

          for (let itpl = 0; dataSrc.data != null && itpl < dataSrc.data.length; itpl++) {
            let thisRec: basecodereference = <basecodereference>dataSrc.data[itpl];
            if (thisRec == null) {
              continue;
            }

            let subtype = this.parseTableSubType(srckey);

            let srcTable: IcemattableSettings = <IcemattableSettings>this.srcTypeMapTable[srckey];
            if (srcTable == null)
              continue;

            // filter sub types
            let subTypeAry = this.sBill.SUBTYPES.filter(s => s.src_type == srctype && s.sub_type == subtype);

            let subTypeFilter: subtypereference = null;
            if (subTypeAry != null && subTypeAry.length > 0) {
              subTypeFilter = subTypeAry[0];
            }
            else {
              subTypeFilter = new subtypereference();
              subTypeFilter.sub_type_reference_key = Iceutility.guid(true).toUpperCase();
              this.sBill.SUBTYPES.push(subTypeFilter);
            }

            subTypeFilter.src_type = srctype;
            subTypeFilter.sub_type = subtype;

            let codeAry = subTypeFilter.CODES.filter(c => c.base_code_reference_key == thisRec.base_code_reference_key);
            let codeFilter: basecodereference = null;
            let taxStatus: any = thisRec.tax_status;

            if (codeAry != null && codeAry.length > 0) {
              codeFilter = codeAry[0];
              codeFilter.title = thisRec.title;
              codeFilter.code = thisRec.code;
              codeFilter.price = thisRec.price;
              codeFilter.tax_status = taxStatus === "Taxable" ? 1 : 2;
            }
            else {
              codeFilter = new basecodereference();
              codeFilter.base_code_reference_key = thisRec.base_code_reference_key;
              codeFilter.code_list_qualifier_code = thisRec.code_list_qualifier_code;
              codeFilter.base_code_key = thisRec.base_code_key;
              codeFilter.title = thisRec.title;
              codeFilter.code = thisRec.code;
              codeFilter.price = thisRec.price;
              codeFilter.tax_status = taxStatus === "Taxable" ? 1 : 2;
              subTypeFilter.CODES.push(codeFilter);
            }
          }
        }
      }
      catch (e) {
        console.log(e);
      }

      if (this.sBill.superbill_key == null || this.sBill.superbill_key.length == 0) {
        this.accSvc.addBillTemplate(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.sBill).subscribe(
          data => {
            // To do is error then stay on view
            this.router.navigate([this.navSvc.buildRoute("accounting/billingtemplates", false)]);
          },
          error => {
            console.log(JSON.stringify(this.accSvc.getLastErrors()));
          });
      }
      else {
        this.accSvc.updateBillTemplate(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.sBill).subscribe(
          data => {
            // To do is error then stay on view
            this.router.navigate([this.navSvc.buildRoute("accounting/billingtemplates", false)]);
          },
          error => {
            console.log(JSON.stringify(this.accSvc.getLastErrors()));
          });
      }
    }
  }

}
